<div class="view_or_download" *ngIf="display">
  <a href="#" (click)="onClickView($event)">View</a> | <a href="#" class="view_or_download__download" (click)="onClickDownload($event)">{{this.downloadButtonLabel}}</a>
</div>